import { DeliveryFilter } from "./components/delivery/delivery";
import { FinishFilter } from "./components/finish/finish";
import { VolumeFilter } from "./components/volume/volume";
import { Base } from "./filters.base";

export const Filters = Object.assign(Base, {
    Delivery: DeliveryFilter,
    Volume: VolumeFilter,
    Finish: FinishFilter
});
